import React from "react"
import ContentLoader from "react-content-loader"
import classNames from "../../../utils/classnameUtils";
import './styles.scss';

const Skeleton = ({
  classNameProps,
  backgroundColorOne,
  backgroundColorTwo
}) => {


  const contentSkeleton = {
    speed: 2,
    backgroundColor: backgroundColorOne,
    foregroundColor: backgroundColorTwo,
  }

  const titleSkeleton = {
    width: '50%',
    height: 1,
  }

  const subTitleSkeleton = {
    width: '30%',
    height: 1,
  }

  const textSkeleton = {
    width: '100%',
    height: 2,
  }

  return (
    <div className={classNames(classNameProps, 'episodesSkeletonContainer')} >
      {
        <ContentLoader viewBox={`0 0 ${20} ${1}`} className='episodesSkeletonTitle' {...contentSkeleton}>
          <rect {...titleSkeleton} rx="0.2"/>
        </ContentLoader>}
      {
        <ContentLoader viewBox={`0 0 ${20} ${1}`} className='episodesSkeletonSubTitle' {...contentSkeleton}>
          <rect {...subTitleSkeleton} rx="0.2"/>
        </ContentLoader>}
      {/*<ContentLoader viewBox={`0 0 ${20} ${2}`} className='episodesSkeletonText' {...contentSkeleton}>
        <rect {...textSkeleton} />
      </ContentLoader>*/}
    </div>
  )
}

export default Skeleton;